import { useQuery } from "@tanstack/react-query";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { orgChartApi } from "./client";

export const orgChartKeys = {
  all: ["org-chart"] as const,
  overview: (params: { departmentId?: string; includeInactive?: boolean }) =>
    ["org-chart", "overview", params] as const,
  departments: (query: Partial<OffsetPageQueryDTO>) =>
    ["org-chart", "departments", query] as const,
  positions: (query: Partial<OffsetPageQueryDTO>) =>
    ["org-chart", "positions", query] as const,
};

export function useOrgChartOverview(
  params: { departmentId?: string; includeInactive?: boolean } = {},
) {
  return useQuery({
    queryKey: orgChartKeys.overview(params),
    queryFn: () => orgChartApi.getOverview(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useOrgChartDepartments(
  query: Partial<OffsetPageQueryDTO> = {},
) {
  const q: OffsetPageQueryDTO = {
    limit: query.limit ?? 20,
    offset: query.offset ?? 0,
    sort: query.sort,
    filters: query.filters,
  };
  return useQuery({
    queryKey: orgChartKeys.departments(q),
    queryFn: () => orgChartApi.listDepartments(q),
  });
}

export function useOrgChartPositions(query: Partial<OffsetPageQueryDTO> = {}) {
  const q: OffsetPageQueryDTO = {
    limit: query.limit ?? 20,
    offset: query.offset ?? 0,
    sort: query.sort,
    filters: query.filters,
  };
  return useQuery({
    queryKey: orgChartKeys.positions(q),
    queryFn: () => orgChartApi.listPositions(q),
  });
}
